import {
  Component,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LookupModalService } from 'src/app/_services/PSP/modals.service';

@Component({
  selector: 'app-choose-customer-modal',
  templateUrl: './choose-customer-modal.component.html',
  styleUrls: ['./choose-customer-modal.component.scss'],
})
export class ChooseCustomerModalComponent implements OnInit {
  notificationModal: BsModalRef;
  notification = {
    keyboard: true,
    class: 'modal-dialog-centered modal-black',
  };

  @ViewChild('modalNotification') modalNotification;
  constructor(
    private router: Router,
    private modalService: BsModalService,
    private myModalService: LookupModalService
  ) {}

  patientIcon = 'assets/img/icons/psp/patient-black.png';
  caregiverIcon = 'assets/img/icons/psp/caregiver-purple.png';

  // modalRequiredWidth: number = 0.4 * window.innerWidth;
  // modalRequiredHeight: number = 0.39 * window.innerHeight;
  // modalSize = `width: ${this.modalRequiredWidth}px; min-height: ${this.modalRequiredHeight}px`;
  // continueBtnSize = `width: ${0.28 * this.modalRequiredWidth}px; max-height: ${
  //   0.12 * this.modalRequiredHeight
  // }px`;

  selectedBox = 'caregiverBox';

  patientBoxStyle = 'modal-box-unselected';
  caregiverBoxStyle = 'modal-box-selected';


  ngOnInit(): void {
    this.myModalService.chooseTypeModal.subscribe((res) => {
      if (res && this.modalService.getModalsCount() == 0) {

        this.openNotificationModal();
      }
    });
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //     if (this.openModal){
  //       this.openNotificationModal();
  //     }
  // }

  // @HostListener('window:resize', ['$event'])
  // onResize(event): void {
  //   this.modalRequiredWidth = 0.4 * event.target.innerWidth;
  //   this.modalRequiredHeight = 0.39 * event.target.innerHeight;
  //   this.modalSize = `width: ${this.modalRequiredWidth}px; min-height: ${this.modalRequiredHeight}px`;
  //   this.continueBtnSize = `width: ${
  //     0.28 * this.modalRequiredWidth
  //   }px; max-height: ${0.12 * this.modalRequiredHeight}px`;
  // }

  openNotificationModal(): void {
    this.notificationModal = this.modalService.show(
      this.modalNotification,
      this.notification
    );
  }

  changeIcons(boxType: string): void {
    if (boxType == 'patientBox') {
      this.patientIcon = 'assets/img/icons/psp/patient-purple.png';
      this.caregiverIcon = 'assets/img/icons/psp/caregiver-black.png';
      this.patientBoxStyle = 'modal-box-selected';
      this.caregiverBoxStyle = 'modal-box-unselected';
    } else if (boxType == 'caregiverBox') {
      this.patientIcon = 'assets/img/icons/psp/patient-black.png';
      this.caregiverIcon = 'assets/img/icons/psp/caregiver-purple.png';
      this.patientBoxStyle = 'modal-box-unselected';
      this.caregiverBoxStyle = 'modal-box-selected';
    }
    this.selectedBox = boxType;
  }

  onSubmit(modal): void {
    this.notificationModal.hide();
    if (this.selectedBox == 'caregiverBox') {
      this.router.navigateByUrl('psp/add-caregiver');
    } else {
      this.router.navigateByUrl('psp/add-patient');
    }
    this.notificationModal.hide();
  }
}
